var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.334,
    height: 225.13,
    viewBox: "0 0 177.334 225.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0tn00bnhoa",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EEAFF",
    stopOpacity: 0.388
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lhe894jvrb",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#c19d7c",
    stopOpacity: 0.831
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EEAFF",
    stopOpacity: 0.122
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1500"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1482"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15815",
    d: "m625.19 423.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-518.671 -330.945)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15816",
    d: "m676.19 394.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-551.83 -312.09)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15817",
    d: "m726.19 365.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-584.339 -293.235)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15818",
    d: "m776.19 336.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-616.847 -274.38)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15819",
    d: "m826.19 307.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-649.356 -255.524)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15820",
    d: "m575.19 394.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-486.162 -312.09)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15821",
    d: "m626.19 365.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-519.321 -293.235)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15822",
    d: "m676.19 336.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-551.83 -274.38)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15823",
    d: "m726.19 307.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-584.339 -255.524)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15824",
    d: "m776.19 278.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-616.847 -236.669)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15825",
    d: "m525.19 365.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-453.653 -293.235)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15826",
    d: "m576.19 336.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-486.812 -274.38)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15827",
    d: "m626.19 307.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-519.321 -255.524)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15828",
    d: "m676.19 278.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-551.83 -236.669)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15829",
    d: "m726.19 249.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-584.339 -217.814)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15830",
    d: "m475.19 336.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-421.144 -274.38)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15831",
    d: "m526.19 307.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-454.303 -255.524)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15832",
    d: "m576.19 278.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-486.812 -236.669)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15833",
    d: "m626.19 249.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-519.321 -217.814)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15834",
    d: "m676.19 220.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-551.83 -198.959)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15835",
    d: "m424.19 307.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-387.985 -255.524)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15836",
    d: "m475.19 278.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-421.144 -236.669)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15837",
    d: "m525.19 249.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-453.653 -217.814)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15838",
    d: "m575.19 220.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-486.162 -198.959)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15839",
    d: "m625.19 191.335-17.525 10.119-.036.021-.036-.021-17.525-10.119 17.525-10.118.036-.021.036.021z",
    transform: "translate(-518.671 -180.104)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15840",
    d: "M607.525 452.5v20.278L590 462.657l-.036-.021v-20.279l17.526 10.119z",
    transform: "translate(-518.603 -349.905)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15841",
    d: "M557.242 423.444v20.278L539.717 433.6l-.036-.021V413.3l17.526 10.119z",
    transform: "translate(-485.91 -331.016)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15842",
    d: "M506.959 394.391v20.278l-17.525-10.118-.036-.021v-20.278l17.526 10.119z",
    transform: "translate(-453.217 -312.126)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15843",
    d: "M456.675 365.339v20.278L439.15 375.5l-.036-.021V355.2l17.526 10.119z",
    transform: "translate(-420.524 -293.237)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15844",
    d: "M406.392 336.286v20.278l-17.525-10.118-.036-.021v-20.278l17.526 10.118z",
    transform: "translate(-387.831 -274.348)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15845",
    d: "M607.525 510.6v20.28L590 520.762l-.036-.021v-20.279l17.526 10.119z",
    transform: "translate(-518.603 -387.684)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15846",
    d: "M557.242 481.549v20.278l-17.525-10.118-.036-.021V471.41l17.526 10.119z",
    transform: "translate(-485.91 -368.795)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15847",
    d: "M506.959 452.5v20.278l-17.525-10.118-.036-.021v-20.282l17.526 10.119z",
    transform: "translate(-453.217 -349.905)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15848",
    d: "M456.675 423.444v20.278L439.15 433.6l-.036-.021V413.3l17.526 10.119z",
    transform: "translate(-420.524 -331.016)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15849",
    d: "M406.392 394.391v20.278l-17.525-10.118-.036-.021v-20.278l17.526 10.119z",
    transform: "translate(-387.831 -312.126)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15850",
    d: "M607.525 568.707v20.278L590 578.867l-.036-.021v-20.279l17.526 10.119z",
    transform: "translate(-518.603 -425.463)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15851",
    d: "M557.242 539.654v20.278l-17.525-10.118-.036-.021v-20.278l17.526 10.119z",
    transform: "translate(-485.91 -406.573)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15852",
    d: "M506.959 510.6v20.28l-17.525-10.118-.036-.021v-20.279l17.526 10.119z",
    transform: "translate(-453.217 -387.684)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15853",
    d: "M456.675 481.549v20.278l-17.525-10.118-.036-.021V471.41l17.526 10.119z",
    transform: "translate(-420.524 -368.795)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15854",
    d: "M406.392 452.5v20.278l-17.525-10.118-.036-.021v-20.282l17.526 10.119z",
    transform: "translate(-387.831 -349.905)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15855",
    d: "M607.525 626.812v20.278L590 636.972l-.036-.021v-20.278l17.526 10.119z",
    transform: "translate(-518.603 -463.241)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15856",
    d: "M557.242 597.76v20.278l-17.525-10.118-.036-.021V587.62l17.526 10.119z",
    transform: "translate(-485.91 -444.352)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15857",
    d: "M506.959 568.707v20.278l-17.525-10.118-.036-.021v-20.279l17.526 10.119z",
    transform: "translate(-453.217 -425.463)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15858",
    d: "M456.675 539.654v20.278l-17.525-10.118-.036-.021v-20.278l17.526 10.119z",
    transform: "translate(-420.524 -406.573)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15859",
    d: "M406.392 510.6v20.28l-17.525-10.118-.036-.021v-20.279l17.526 10.119z",
    transform: "translate(-387.831 -387.684)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15860",
    d: "M607.525 684.917v20.278L590 695.077l-.036-.021v-20.278L607.49 684.9z",
    transform: "translate(-518.603 -501.02)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15861",
    d: "M557.242 655.865v20.278l-17.525-10.118-.036-.021v-20.279l17.526 10.119z",
    transform: "translate(-485.91 -482.131)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15862",
    d: "M506.959 626.812v20.278l-17.525-10.118-.036-.021v-20.278l17.526 10.119z",
    transform: "translate(-453.217 -463.241)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15863",
    d: "M456.675 597.76v20.278l-17.525-10.119-.036-.021V587.62l17.526 10.119z",
    transform: "translate(-420.524 -444.352)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15864",
    d: "M406.392 568.707v20.278l-17.525-10.118-.036-.021v-20.279l17.526 10.119z",
    transform: "translate(-387.831 -425.463)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15865",
    d: "M607.525 743.022V763.3L590 753.182l-.036-.021v-20.278L607.49 743z",
    transform: "translate(-518.603 -538.799)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15866",
    d: "M557.242 713.97v20.278l-17.525-10.118-.036-.021V703.83l17.526 10.119z",
    transform: "translate(-485.91 -519.909)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15867",
    d: "M506.959 684.917v20.278l-17.525-10.118-.036-.021v-20.278l17.525 10.122z",
    transform: "translate(-453.217 -501.02)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15868",
    d: "M456.675 655.865v20.278l-17.525-10.118-.036-.021v-20.279l17.526 10.119z",
    transform: "translate(-420.524 -482.131)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15869",
    d: "M406.392 626.812v20.278l-17.525-10.118-.036-.021v-20.278l17.526 10.119z",
    transform: "translate(-387.831 -463.241)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15870",
    d: "M657.934 442.357v20.278l-.036.021-17.525 10.118V452.5l.036-.021z",
    transform: "translate(-551.378 -349.905)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15871",
    d: "M708.5 413.025V433.3l-.036.021-17.525 10.118v-20.274l.036-.021z",
    transform: "translate(-584.252 -330.834)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15872",
    d: "M758.5 384.252v20.278l-.036.021-17.525 10.118v-20.278l.036-.021z",
    transform: "translate(-616.764 -312.126)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15873",
    d: "M808.5 355.479v20.278l-.036.021-17.521 10.122v-20.282l.036-.021z",
    transform: "translate(-649.275 -293.419)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15874",
    d: "M858.788 326.426V346.7l-.036.021-17.525 10.118v-20.273l.036-.021z",
    transform: "translate(-681.968 -274.529)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15875",
    d: "M625.159 442.2v.041l-17.526 10.119-.036.021v20.278l-.036.021-.036-.021v-20.278l-.036-.021-17.526-10.118v-.042l.036-.021 17.526 10.121.036.021.036-.021 17.525-10.119z",
    transform: "translate(-518.603 -349.789)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15876",
    d: "M781.694 326h.1l-.1.057z",
    transform: "translate(-643.262 -274.252)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15877",
    d: "M640.237 471.1v20.382h-.073V471.1l.036.021z",
    transform: "translate(-551.243 -368.595)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15878",
    d: "M782.071 326v.057l-.1-.057z",
    transform: "translate(-643.443 -274.252)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15879",
    d: "M589.93 500.207v.041l-.018-.031z",
    transform: "translate(-518.569 -387.518)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15880",
    d: "m590 500.346-.018.01-.018-.031z",
    transform: "translate(-518.603 -387.595)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15881",
    d: "m657.751 442.212-.018.01-17.526 10.119-.036.021-.036.02-.036.021v-.041l-.036-.021.036-.021.036-.02.036-.021L657.7 442.16l.018-.01z",
    transform: "translate(-551.177 -349.77)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15882",
    d: "M657.934 500.462v20.278l-.036.021-17.526 10.119V510.6l.036-.021z",
    transform: "translate(-551.378 -387.684)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15883",
    d: "M708.5 471.13v20.278l-.036.021-17.525 10.118V481.27l.036-.021z",
    transform: "translate(-584.252 -368.613)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15884",
    d: "M758.5 442.357v20.278l-.036.021-17.525 10.118V452.5l.036-.021z",
    transform: "translate(-616.764 -349.905)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15885",
    d: "M808.5 413.584v20.278l-.036.021L790.943 444v-20.277l.036-.021z",
    transform: "translate(-649.275 -331.197)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15886",
    d: "M858.788 384.531v20.279l-.036.021-17.525 10.118v-20.278l.036-.021z",
    transform: "translate(-681.968 -312.308)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15887",
    d: "m657.751 500.317-.018.01-17.526 10.118-.036.021-.036.02-.036.021v-.041l-.036-.021.036-.021.036-.02.036-.021 17.529-10.118.018-.01z",
    transform: "translate(-551.177 -387.549)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15888",
    d: "M708.5 529.235v20.278l-.036.021-17.525 10.118v-20.277l.036-.021z",
    transform: "translate(-584.252 -406.392)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15889",
    d: "M758.5 500.462v20.278l-.036.021-17.525 10.119V510.6l.036-.021z",
    transform: "translate(-616.764 -387.684)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15890",
    d: "M808.5 471.689v20.278l-.036.021-17.525 10.118v-20.277l.036-.021z",
    transform: "translate(-649.275 -368.976)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15891",
    d: "M858.788 442.636v20.278l-.036.021-17.525 10.118v-20.277l.036-.021z",
    transform: "translate(-681.968 -350.087)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15892",
    d: "m657.751 558.422-.018.01-17.526 10.119-.036.021-.036.02-.036.021v-.041l-.036-.021.036-.021.036-.02.036-.021L657.7 558.37l.018-.01z",
    transform: "translate(-551.177 -425.328)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15893",
    d: "M657.934 616.673v20.278l-.036.021-17.526 10.118v-20.278l.036-.021z",
    transform: "translate(-551.378 -463.241)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15894",
    d: "M708.5 587.341v20.278l-.036.021-17.525 10.118V597.48l.036-.021z",
    transform: "translate(-584.252 -444.17)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15895",
    d: "M758.5 558.567v20.278l-.036.021-17.525 10.118v-20.277l.036-.021z",
    transform: "translate(-616.764 -425.463)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15896",
    d: "M808.5 529.794v20.278l-.036.021-17.525 10.118v-20.277l.036-.021z",
    transform: "translate(-649.275 -406.755)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15897",
    d: "M858.788 500.742v20.278l-.036.021-17.525 10.118v-20.278l.036-.021z",
    transform: "translate(-681.968 -387.865)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15898",
    d: "m657.751 616.527-.018.01-17.526 10.118-.036.021-.036.02-.036.021v-.041l-.036-.021.036-.021.036-.02.036-.021 17.529-10.118.018-.01z",
    transform: "translate(-551.177 -463.106)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15899",
    d: "M657.934 675.336v20.278l-.036.021-17.525 10.118v-20.277l.036-.021z",
    transform: "translate(-551.378 -501.383)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15900",
    d: "M708.5 646v20.279l-.036.021-17.525 10.118v-20.274l.036-.021z",
    transform: "translate(-584.252 -482.312)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15901",
    d: "M758.5 617.231v20.279l-.036.021-17.525 10.118v-20.278l.036-.021z",
    transform: "translate(-616.764 -463.605)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15902",
    d: "M808.5 588.458v20.278l-.036.021-17.525 10.118V598.6l.036-.021z",
    transform: "translate(-649.275 -444.897)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15903",
    d: "M858.788 559.405v20.278l-.036.021-17.525 10.118v-20.277l.036-.021z",
    transform: "translate(-681.968 -426.007)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15904",
    d: "m657.751 675.191-.018.01-17.526 10.119-.036.021-.036.02-.036.021v-.041l-.036-.021.036-.021.036-.02.036-.021 17.529-10.119.018-.01z",
    transform: "translate(-551.177 -501.248)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15905",
    d: "M657.934 733.442v20.278l-.036.021-17.525 10.118v-20.278l.036-.021z",
    transform: "translate(-551.378 -539.162)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15906",
    d: "M708.5 704.11v20.278l-.036.021-17.525 10.118v-20.278l.036-.021z",
    transform: "translate(-584.252 -520.091)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15907",
    d: "M758.5 675.336v20.278l-.036.021-17.525 10.118v-20.277l.036-.021z",
    transform: "translate(-616.764 -501.383)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15908",
    d: "M808.5 646.563v20.278l-.036.021-17.521 10.118V656.7l.036-.021z",
    transform: "translate(-649.275 -482.676)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15909",
    d: "M858.788 617.511v20.278l-.036.021-17.525 10.118V627.65l.036-.021z",
    transform: "translate(-681.968 -463.786)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15910",
    d: "m657.751 733.3-.018.01-17.526 10.119-.036.021-.036.02-.036.021v-.041l-.036-.021.036-.021.036-.02.036-.021 17.529-10.123.018-.01z",
    transform: "translate(-551.177 -539.027)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15911",
    d: "m607.6 452.341-.036.021v.041l-.036-.021-.036-.02-.036-.021-17.526-10.119-.018-.01.036-.062.018.01 17.525 10.119.036.021.036.02z",
    transform: "translate(-518.569 -349.77)",
    style: {
      stroke: "#ff9d29",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17788",
    d: "m956-3657.717 87.224 51.147 88.776-51.147-88.776-50.417z",
    transform: "translate(-956 3708.134)",
    style: {
      opacity: 0.23,
      fill: "url(#0tn00bnhoa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17790",
    d: "M1146.784-3460.8v121.36l-88.917-53.1v-118.934z",
    transform: "translate(-1056.867 3564.134)",
    style: {
      opacity: 0.64,
      fill: "url(#lhe894jvrb)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningCube);
export default __webpack_public_path__ + "static/media/learning_cube.52643a7429cffb95688af681a2f9cd13.svg";
export { ForwardRef as ReactComponent };